/*
 * @Author: cc
 * @Date: 2021-04-20 19:12:54
 * @LastEditTime: 2021-11-19 15:39:35
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\components\util\headerLogo\faviconLogo.js
 * @Description: 
 */
// 'use strict';
app.run(['$rootScope', 'globleParamsSet', function($rootScope, globleParamsSet) {
    globleParamsSet.getTenantLogo().then(function(data) {
        updateLogo(data.LOGO_2, data.INTRO);
    });
    $rootScope.$on('updateTenantLogo', function(event, data) {
        updateLogo(data.url, data.name);
    });
    window.addEventListener('storage', function(e) {
        if (e.key === 'updateTenantLogo') {
            var data = JSON.parse(e.newValue);
            updateLogo(data.url, data.name);
        }
    });

    /**
     * [updateLogo description] 更新logo和title
     * @param   {[type]}  imgSrc  [imgSrc description]
     * @param   {[type]}  title   [title description]
     * @return  {[type]}          [return description]
     */
    function updateLogo(imgSrc, title) {
        $('.faviconLogo').attr('href', imgSrc);
        $('.indexTitle').html(title || '');
    }
}]);
